import { render } from "./ClassesPage.vue?vue&type=template&id=49f861ae"
import script from "./ClassesPage.vue?vue&type=script&lang=js"
export * from "./ClassesPage.vue?vue&type=script&lang=js"

import "./ClassesPage.vue?vue&type=style&index=0&id=49f861ae&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__